import router from '../../router'
import EventService from '../../services/EventService'

const state = () => ({
    loadingEvents: false,
    evemt: null,
    events: [],
    total: 0,
    pages: 0,
    page: 1,
    show_modal_new_evemt: false
})
  
const mutations = {
    SET_EVENT: (state, payload) => {
        state.evemt = payload
    },
    SET_EVENTS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.events = payload.items
        }else{
            state.events = [...state.events, ...payload.items]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total

    },
    SET_LOADING_EVENTS: (state, payload) => {
        state.loadingEvent = payload
    },
    SET_SHOW_MODAL_EVENT: (state, payload) => {
        state.show_modal_new_evemt = payload
    },
}

const actions = {
    async fetchEvent({commit}, id){
        try{
            commit('SET_LOADING_EVENTS', true)
            const response = await EventService.getOne(id);
            commit('SET_EVENT', response.data)
            commit('SET_LOADING_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_EVENTS', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
            }
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchEvents({commit}, params = {}){
        try{
            commit('SET_LOADING_EVENTS', true)
            const { start = '', end = '', keyword = '', pageNumber = 1, pageSize = 1000, order = { name: 'ID', column: 'ID', sort: 'ASC' } } = params;
            const response = await EventService.get(start, end, keyword, pageNumber, pageSize, order);
            commit('SET_EVENTS', response.data)
            commit('SET_LOADING_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_EVENTS', false);
            // if(error && error.response && error.response.data.message == "Sessão expirada") {
            //     commit('SET_REDIRECT', router.currentRoute.value.path);
            // }
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async createEvent({commit}, data){
        try{
            commit('SET_LOADING_EVENTS', true)
            const response = await EventService.create(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            window.location.reload();
            commit('SET_SHOW_MODAL_EVENT', false)
            commit('SET_LOADING_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_EVENTS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async updateEvent({commit}, data){
        try{
            commit('SET_LOADING_EVENTS', true)
            const response = await EventService.update(data);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_LOADING_EVENTS', false)
        } catch (error) {
            commit('SET_LOADING_EVENTS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async deleteEvent({commit}, id) {
        try{
            commit('SET_LOADING_EVENTS', true);
            const response = await EventService.delete(id);
            window.location.reload();
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            commit('SET_SHOW_MODAL_CONFIRMATION', false);
            commit('SET_LOADING_EVENTS', false);
        } catch (error) {
            commit('SET_LOADING_EVENTS', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    }
}

const getters = {
    getEvent: state => state.evemt,
    getEvents: state => state.events,
    getLoadingEvent: state => state.loadingEvent,
    getShowModalNewEvent: state => state.show_modal_new_evemt
}

export default {
    state,
    getters,
    mutations,
    actions
};